import { html } from "lit";

// Back-arrow + X icon for removing a shape from the shape selector
export const iconRemoveShape = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  version="1.1"
  baseProfile="tiny"
  viewBox="-0.75 7.25 7.5 9.5"
  fill="none"
  stroke="currentColor"
  stroke-linejoin="round"
  stroke-linecap="round"
  stroke-width="0.5"
>
  <path d="M0,12L2,10M0,12L2,14M2,10H6M2,14H6M6,10V14M3,11L5,13M3,13L5,11"></path>
</svg>`;
